import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { TenantProfileService } from './tenant-profile.service';
import { ParkingProfileFlags } from '../SuperAdmin/tenant.service';

@Injectable({ providedIn: 'root' })
export class ParkingProfileService {
  private readonly profileSubject = new BehaviorSubject<number | null>(null);

  readonly parkingProfile$ = this.profileSubject.asObservable();

  constructor(private readonly tenantProfileService: TenantProfileService) {}

  /** Carga el perfil comercial del tenant autenticado (GET /Tenant/me). */
  load(): Observable<number> {
    return this.tenantProfileService.getMyTenant().pipe(
      map((t) => t.parkingProfile ?? ParkingProfileFlags.Full),
      tap((profile) => this.profileSubject.next(profile))
    );
  }

  getSnapshot(): number | null {
    return this.profileSubject.value;
  }

  hasAcceso(profile: number | null = this.getSnapshot()): boolean {
    if (profile == null) {
      return false;
    }
    return (profile & ParkingProfileFlags.Acceso) !== 0;
  }

  ensureLoaded(): Observable<number> {
    const current = this.getSnapshot();
    if (current != null) {
      return of(current);
    }
    return this.load();
  }

  /** Sincroniza perfil ya obtenido (p. ej. desde GET /Tenant/me). */
  setProfile(profile: number): void {
    this.profileSubject.next(profile);
  }
}
